import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Comanda } from '../models/comanda.model';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';
import { ComandaStatus } from '../models/comanda.model';

export interface CreateComandaDto {
  idsMesa: number[];
  observation?: string | null;
}

export interface AddComandaItemDto {
  productId: number;
  quantity: number;
  observation?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ComandaService {
  private readonly baseUrl = `${environment.base_url}/comandas`;

  constructor(private http: HttpClient) {}

  list(status?: ComandaStatus, mesaId?: number, page: number = 1): Observable<RestResponse<Comanda[]>> {
    const params: any = { page: String(page) };
    if (status) params.status = status;
    if (mesaId != null) params.mesaId = mesaId.toString();
    return this.http.get<RestResponse<Comanda[]>>(`${this.baseUrl}/list`, { params });
  }

  find(id: number): Observable<RestResponse<Comanda>> {
    return this.http.get<RestResponse<Comanda>>(`${this.baseUrl}/find/${id}`);
  }

  /** Retorna a comanda aberta vinculada à mesa, se existir. */
  findByTable(tableId: number): Observable<RestResponse<Comanda>> {
    return this.http.get<RestResponse<Comanda>>(`${this.baseUrl}/find-by-table/${tableId}`);
  }

  create(dto: CreateComandaDto): Observable<RestResponse<Comanda>> {
    return this.http.post<RestResponse<Comanda>>(`${this.baseUrl}/create`, dto);
  }

  addItem(id: number, dto: AddComandaItemDto): Observable<RestResponse<Comanda>> {
    return this.http.post<RestResponse<Comanda>>(`${this.baseUrl}/${id}/itens`, dto);
  }

  removeItem(id: number, itemId: number): Observable<RestResponse<object>> {
    return this.http.delete<RestResponse<object>>(`${this.baseUrl}/${id}/itens/${itemId}`);
  }

  fechar(id: number): Observable<RestResponse<Comanda>> {
    return this.http.put<RestResponse<Comanda>>(`${this.baseUrl}/${id}/fechar`, null);
  }

  cancelar(id: number): Observable<RestResponse<Comanda>> {
    return this.http.put<RestResponse<Comanda>>(`${this.baseUrl}/${id}/cancelar`, null);
  }
}
